/*
 * @Author: 时不待我 790002517@qq.com
 * @Date: 2023-04-14 16:14:35
 * @LastEditors: 时不待我 790002517@qq.com
 * @LastEditTime: 2023-04-17 11:58:16
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  router,
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js